import React from "react";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { Card } from "react-bootstrap";

export const LicenseConfirmationPopUp = (props) => {
  const { setPopUp, toDeleteUserId, removeLicenseById, toDeleteLicenseData } =
    props;

  return (
    <Card
      style={{
        position: "fixed",
        left: "0",
        top: "0",
        backgroundColor: "rgba(0, 0, 0,0.5)",
        height: "100%",
        width: "100%",
      }}
    >
      <div
        style={{
          position: "relative",
          marginLeft: "35vw",
          marginTop: "35vh",
          backgroundColor: "#ffffff",
          borderRadius: "3px",
          height: "30vh",
          width: "30vw",
        }}
      >
        <p
          style={{
            margin: "1vh",
            color: "#000000",
          }}
        >
          Do you want to delete a license from this user?
        </p>
        <div style={{ position: "absolute", bottom: "2vh", right: "2vh" }}>
          <PrimaryButton
            style={{
              position: "relative",
            }}
            onClick={() => {
              removeLicenseById(toDeleteLicenseData);
              setPopUp(false);
            }}
            text={"Confirm"}
          />
          <DefaultButton
            style={{
              position: "relative",
              marginLeft: "1vh",
            }}
            text={"Decline"}
            onClick={() => setPopUp(false)}
          />
        </div>
      </div>
    </Card>
  );
};
